/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_BenchmarksInputs */

const en_directory_detail_section_benchmarks = /** @type {(inputs: Directory_Detail_Section_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmarks`)
};

const zh_directory_detail_section_benchmarks = /** @type {(inputs: Directory_Detail_Section_BenchmarksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基准测试`)
};

/**
* | output |
* | --- |
* | "Benchmarks" |
*
* @param {Directory_Detail_Section_BenchmarksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_benchmarks = /** @type {((inputs?: Directory_Detail_Section_BenchmarksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_BenchmarksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_benchmarks(inputs)
	return zh_directory_detail_section_benchmarks(inputs)
});
export { directory_detail_section_benchmarks as "directory.detail.section.benchmarks" }